import { Component, inject, signal } from '@angular/core';
import { Helpers } from '../../../../../utilities/helpers';
import { ApiEndpoints } from '../../../../../core/api-endpoints';
import { DashboardService } from '../../../../../services/dashboard';
import { FlashService } from '../../../../../services/flash';
import { DecodedToken, Session } from '../../../../../services/session';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-fee-overview',
  imports: [DecimalPipe],
  templateUrl: './fee-overview.html',
  styleUrl: './fee-overview.css',
})
export class FeeOverview {
  constructor(
    private dashboardService: DashboardService,
    private session: Session,
  ) {
    const token = this.session.getItem('token');

    this.loggedUser.set(this.session.decodeToken(token));

    if (!this.loggedUser()?.sub) {
      return;
    }

    if (this.loggedUser()?.role !== 'SUPER_ADMIN') {
      this.getRecentPayments();
      this.getStudentFeeStatus();
      this.getClassFeeStats();
    }
  }

  protected readonly Helpers = Helpers;
  protected recentPayments = signal<any>(null);
  protected studentFeeStatus = signal<any>(null);
  protected classFeeStats = signal<any>(null);
  protected isLoading = signal<boolean>(false);
  protected readonly flashService = inject(FlashService);
  protected loggedUser = signal<DecodedToken | null>(null);

  protected getRecentPayments(): void {
    this.isLoading.set(true);

    this.dashboardService
      .getDashboardData(`${ApiEndpoints.url}/dashboard/latest-payments`)
      .subscribe({
        next: (res) => {
          this.recentPayments.set(res.payload);
          this.isLoading.set(false);
        },
        error: (err) => {
          this.flashService.failure(err?.error?.message ?? 'Failed to load dashboard. Refresh the page.');
        },
      });
  }

  protected getStudentFeeStatus(): void {
    this.isLoading.set(true);

    this.dashboardService
      .getDashboardData(`${ApiEndpoints.url}/dashboard/student-fee-status`)
      .subscribe({
        next: (res) => {
          this.studentFeeStatus.set(res.payload);
          this.isLoading.set(false);
        },
        error: (err) => {
          this.flashService.failure(err?.error?.message ?? 'Failed to load dashboard. Refresh the page.');
        },
      });
  }

  protected getClassFeeStats(): void {
    this.isLoading.set(true);

    this.dashboardService
      .getDashboardData(`${ApiEndpoints.url}/dashboard/class-fee-stats`)
      .subscribe({
        next: (res) => {
          this.classFeeStats.set(res.payload);
          this.isLoading.set(false);
        },
        error: (err) => {
          this.flashService.failure(err?.error?.message ?? 'Failed to load dashboard. Refresh the page.');
        },
      });
  }
}
